// pl_pms_common.ts
// Elementy wspólne dla wszystkich ekranów PMS — statusy, akcje, etykiety
// Importuj ten plik w każdym ekranowym pliku tłumaczeń zamiast powielać te same klucze.

export const plPmsCommon = {

  emptyValue: "—",
  yes: "Tak",
  no: "Nie",

  roomWithNumber: "Pokój {{number}}",
  counts: {
    rooms_one: "{{count}} pokój",
    rooms_few: "{{count}} pokoje",
    rooms_many: "{{count}} pokoi",
    rooms_other: "{{count}} pokoju",
    nights_one: "{{count}} noc",
    nights_few: "{{count}} noce",
    nights_many: "{{count}} nocy",
    nights_other: "{{count}} nocy",
    guests_one: "{{count}} gość",
    guests_few: "{{count}} goście",
    guests_many: "{{count}} gości",
    guests_other: "{{count}} gościa",
    adults_one: "{{count}} dorosły",
    adults_few: "{{count}} dorośli",
    adults_many: "{{count}} dorosłych",
    adults_other: "{{count}} dorosłego",
    children_one: "{{count}} dziecko",
    children_few: "{{count}} dzieci",
    children_many: "{{count}} dzieci",
    children_other: "{{count}} dziecka",
  },

  navigation: {
    rooms: "Pokoje i typy pokoi",
    "live-board": "Live Board",
    reservations: "Rezerwacje",
    groups: "Grupy i bloki",
    "room-type-availability": "Dostępność typów pokoi",
    "room-availability-calendar": "Kalendarz pokoi",
    guests: "Goście",
    frontdesk: "Recepcja",
    housekeeping: "Sprzątanie",
    billing: "Rozliczenia",
    "night-audit": "Audyt nocny",
    rates: "Ceny i dostępność",
    channels: "Kanały",
    interfaces: "Interfejsy",
    reports: "Raporty",
  },
  sidebar: {
    dashboard: "Pulpit",
    openModule: "Otwórz {{module}}",
    openExternal: "Otwórz {{module}} (zewnętrzny)",
    openExternalTitle: "Otwórz {{module}} (zewnętrzny, nowa karta)",
    customize: "Dostosuj nawigację",
    expand: "Rozwiń nawigację",
    collapse: "Zwiń nawigację",
    show: "Pokaż nawigację",
    hide: "Ukryj nawigację",
    description: "Wybierz, uporządkuj i rozwiń moduły, aby dostosować ich podsekcje.",
    closeSettings: "Zamknij ustawienia nawigacji",
    subsections_one: "{{count}} podsekcja",
    subsections_few: "{{count}} podsekcje",
    subsections_many: "{{count}} podsekcji",
    subsections_other: "{{count}} podsekcji",
    hideItem: "Ukryj {{item}}",
    showItem: "Pokaż {{item}}",
    shown: "Widoczne",
    hidden: "Ukryte",
    moveItemUp: "Przesuń {{item}} w górę",
    moveItemDown: "Przesuń {{item}} w dół",
    moveUp: "Przesuń w górę",
    moveDown: "Przesuń w dół",
    reset: "Przywróć domyślne",
    done: "Gotowe",
  },
  workspace: {
    identity: "Zarządzanie użytkownikami",
    settings: "Ustawienia",
    language: "Język",
    languageOptions: "Opcje języka",
    active: "Aktywny",
    darkMode: "Tryb ciemny",
    logout: "Wyloguj",
    newReservation: "Nowa rezerwacja",
    startCheckin: "Rozpocznij meldowanie",
  },

  // ── Statusy pokoi ──────────────────────────────────────────────────────────
  roomStatus: {
    available:    "Dostępny",
    occupied:     "Zajęty",
    dirty:        "Brudny",
    clean:        "Czysty",
    cleaning:     "W sprzątaniu",
    inspected:    "Skontrolowany",
    blocked:      "Zablokowany",
    outOfOrder:   "Wyłączony z użytku",
    outOfService: "Poza służbą",
    unassigned:   "Nieprzypisany",
    reserved:     "Zarezerwowany",
    maintenance:  "W konserwacji",
  },

  // ── Statusy rezerwacji ─────────────────────────────────────────────────────
  reservationStatus: {
    confirmed:  "Potwierdzona",
    inHouse:    "Zameldowany",
    cancelled:  "Anulowana",
    checkedOut: "Wymeldowany",
    noShow:     "Nieobecny",
    waitlist:   "Lista oczekujących",
    pending:    "Oczekująca",
    planned:    "Planowana",
    completed:  "Zakończona",
    booked:     "Zarezerwowana",
    active:     "Aktywna",
    all:        "Wszystkie",
  },

  roomCalendar: {
    allTypes: "Wszystkie typy",
    allFloors: "Wszystkie piętra",
    floor: "Piętro {{floor}}",
    filterByFloor: "Filtruj według piętra",
    clearFilters: "Wyczyść",
    checkedOut: "Wymeldowane",
    checkedIn: "Zameldowane",
    cancelledNoShow: "Anulowane / Nieprzybyłe",
    showCheckedOut: "Pokaż wymeldowane rezerwacje",
    hideCheckedOut: "Ukryj wymeldowane rezerwacje",
    reservationLegend: "Legenda statusów rezerwacji i filtr pokoi",
    roomNumberPlaceholder: "Nr pokoju",
    searchRoomNumber: "Wyszukaj numer pokoju",
  },

  // ── Ważność / Priorytet ────────────────────────────────────────────────────
  severity: {
    critical: "Krytyczny",
    high:     "Wysoki",
    medium:   "Średni",
    low:      "Niski",
  },

  // ── Przyciski i akcje ──────────────────────────────────────────────────────
  actions: {
    save:        "Zapisz",
    saving:      "Zapisywanie...",
    cancel:      "Anuluj",
    cancelling:  "Anulowanie...",
    close:       "Zamknij",
    closing:     "Zamykanie...",
    edit:        "Edytuj",
    delete:      "Usuń",
    confirm:     "Potwierdź",
    approve:     "Zatwierdź",
    create:      "Utwórz",
    creating:    "Tworzenie...",
    add:         "Dodaj",
    adding:      "Dodawanie...",
    back:        "Wstecz",
    search:      "Szukaj",
    filter:      "Filtruj",
    refresh:     "Odśwież",
    download:    "Pobierz",
    preview:     "Podgląd",
    print:       "Drukuj",
    send:        "Wyślij",
    modify:      "Modyfikuj",
    viewAll:     "Zobacz wszystko",
    viewDetails: "Zobacz szczegóły",
    opening:     "Otwieranie...",
    set:         "Ustaw",
  },

  // ── Stany komunikatów ──────────────────────────────────────────────────────
  state: {
    loading:   "Ładowanie...",
    noData:    "Brak danych",
    noResults: "Brak wyników",
    failed:    "Nieudane.",
  },

  // ── Wspólne etykiety pól ───────────────────────────────────────────────────
  labels: {
    guest:        "Gość",
    guests:       "Goście",
    room:         "Pokój",
    rooms:        "Pokoje",
    floor:        "Piętro",
    night:        "Noc",
    nights:       "Noce",
    checkIn:      "Zameldowanie",
    checkOut:     "Wymeldowanie",
    arrival:      "Przyjazd",
    departure:    "Odjazd",
    arrivals:     "Przyjazdy",
    departures:   "Odjazdy",
    status:       "Status",
    operations:   "Operacje",
    frontDesk:    "Recepcja",
    occupancy:    "Obłożenie",
    revenue:      "Przychód",
    billing:      "Rozliczenia",
    housekeeping: "Housekeeping",
    department:   "Dział",
    owner:        "Opiekun",
    priority:     "Priorytet",
    date:         "Data",
    time:         "Czas",
    total:        "Łącznie",
    notes:        "Notatki",
    invoice:      "Faktura",
    group:        "Grupa",
    type:         "Typ",
    rate:         "Stawka",
    balance:      "Saldo",
    amount:       "Kwota",
    currency:     "Waluta",
    name:         "Nazwa",
    email:        "Email",
    phone:        "Telefon",
    address:      "Adres",
    country:      "Kraj",
    today:        "Dziś",
    other:        "Inne",
    none:         "Brak",
    unassigned:   "Nieprzypisany",
    inHouse:      "Zameldowani",
    readyRoom:    "Gotowy pokój",
    noReadyRoom:  "Brak gotowego pokoju",
  },

} as const;

export default plPmsCommon;
